import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { CommonService } from '../../../../shared/common.service';
import { InvestmentsHeldPartnershipComponentService } from './service/investments-held-partnership-component.service';
import * as CryptoJS from 'crypto-js';
import Swal from 'sweetalert2';
import { Observable } from 'rxjs';
import { SideNavService } from '../../../../theme/layout/admin/navigation/service/side-nav.service';

@Component({
  selector: 'app-investments-held-partnership',
  templateUrl: './investments-held-partnership.component.html',
  styleUrls: ['./investments-held-partnership.component.scss']
})
export class InvestmentsHeldPartnershipComponent implements OnInit {


  InvestmentsHeldPartnershipFormGroup: FormGroup;
  isJump: any;
  NormalRoutng: boolean;
  showBubbledata: any;
  clear:any
  constructor(public FormBulder: FormBuilder, public InvestmentsHeldPartnershipComponentService: InvestmentsHeldPartnershipComponentService, public Router: Router, public commonService: CommonService, private sidenav: SideNavService) {

  }

  ngOnInit(): void {
    debugger;
    this.commonService.getIncomeStatementsHeaders();
    this.isJump = localStorage.getItem('isJump');
    this.InvestmentsHeldPartnershipform();
    this.GetInvestmentsHeldPartnership();
    this.commonService.getNotesData();
    this.commonService.getImportPageSelectionData(this.commonService.AccountTemplateId, CryptoJS.AES.decrypt(localStorage.getItem("companyId"), "APS").toString(CryptoJS.enc.Utf8), this.InvestmentsHeldPartnershipFormGroup.controls['APPeriodId'].value).subscribe((data) => {
      this.commonService.showBubble = data[0].ImportStatus
      if (this.commonService.showBubble) {
        this.sidenav.setShowBubble(true)
        this.GetInvestmentsHeldPartnership_LY()
      }
    })
    if (localStorage.getItem("SubmitStatus") == "true")
      this.InvestmentsHeldPartnershipFormGroup.disable()
    this.clearfield();
  }

  InvestmentsHeldPartnershipform() {
    this.InvestmentsHeldPartnershipFormGroup = this.FormBulder.group({
      InvestmentsHeldAsCurrentAssetsId: new FormControl(),
      ListedExchangeTraded: new FormControl(),
      ListedExchangeTraded_LY: new FormControl(),
      UnlistedNonøexchangeTraded: new FormControl(),
      UnlistedNonøexchangeTraded_LY: new FormControl(),
      CurrentAssetInvestments: new FormControl({ value: '', disabled: true }),
      CurrentAssetInvestments_LY: new FormControl({ value: '', disabled: true }),
      APPeriodId: new FormControl(CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)),
      CreatedBy: new FormControl(localStorage.getItem('LoginuserId')),
      CreatedDate: new FormControl(),
      ModifiedBy: new FormControl(),
      ModifiedDate: new FormControl(),

      MatchingData: new FormControl(),

    })
  }
  clearfield() {
    this.clear = this.commonService.clearAllFields.subscribe((data: boolean) => {
      if (data) {
        this.InvestmentsHeldPartnershipFormGroup.reset()
      }
    })
  }

  GetInvestmentsHeldPartnership() {
    debugger;
    this.InvestmentsHeldPartnershipComponentService.GetOneInvestmentsHeldPartnership(this.InvestmentsHeldPartnershipFormGroup.controls['APPeriodId'].value).subscribe(data => {
      debugger;
      this.InvestmentsHeldPartnershipFormGroup.patchValue(data);
      this.InvestmentsHeldPartnershipFormGroup.controls['APPeriodId'].patchValue(CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8));
    })
  }
  GetInvestmentsHeldPartnership_LY() {
    debugger;
    this.InvestmentsHeldPartnershipComponentService.GetOneInvestmentsHeldPartnership_LY(this.InvestmentsHeldPartnershipFormGroup.controls['APPeriodId'].value).subscribe(data => {
      debugger;
      this.showBubbledata = data;
      this.InvestmentsHeldPartnershipFormGroup.controls['APPeriodId'].patchValue(CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8));
    })
  }

  On_Next() {
    debugger;
    if (this.On_NextBalancesheatValidaton()) {
      this.InvestmentsHeldPartnershipComponentService.SaveInvestmentsHeldPartnership(this.InvestmentsHeldPartnershipFormGroup.getRawValue()).subscribe(data => {
        this.InvestmentsHeldPartnershipFormGroup.markAsPristine();
        if (this.NormalRoutng)
          return true;
        var nextPage;
        nextPage = this.commonService.getNextNoteSelection("Investments held as current assets", this.commonService.NotesList)
        if (this.isJump == 'true')
          this.Router.navigate(['/notes'])
        else if (nextPage == 'investmentsheldascurrentassets') {
          nextPage = this.commonService.getNextPageSelection("Notes", this.commonService.allPagesdata)
          this.Router.navigate([nextPage]);
        }
        else {
          this.Router.navigate([nextPage]);
        }
      })
      // this.Router.navigate(['/employees']);
    }
    else {
      this.NormalRoutng = false;
      return false;
    }

  }

  On_NextBalancesheatValidaton() {
    debugger;
    if (this.commonService.showControl == true) {
      if (+this.InvestmentsHeldPartnershipFormGroup.controls['CurrentAssetInvestments'].value != this.InvestmentsHeldPartnershipFormGroup.controls['MatchingData'].value.Item1) {
        if (this.commonService.AccountTypeId == 2)
          Swal.fire("Andica Accounts Production", "Total value for the year " + this.commonService.StartYear + " must tally with the Current Assets - Current Investments value in the Trial balance for the year " + this.commonService.StartYear + ".", "warning")
        else
         Swal.fire("Andica Accounts Production", "Total value for the year " + this.commonService.StartYear + " must tally with the Current Assets - Investments value in the balance sheet for the year " + this.commonService.StartYear + ".", "warning")

        //Swal.fire({
        //  text: "'Total' value for the year'" + this.commonService.StartYear + "'must tally with the 'Investments held as current assets' value in the balance sheet for the year " + this.commonService.StartYear + ".",
        //  showConfirmButton: true,
        //  icon: 'warning',

        //})
        return false;
      }
      //else
      //  return true
      else if (+this.InvestmentsHeldPartnershipFormGroup.controls['CurrentAssetInvestments_LY'].value != this.InvestmentsHeldPartnershipFormGroup.controls['MatchingData'].value.Item2) {
        if (this.commonService.AccountTypeId == 2)
        Swal.fire("Andica Accounts Production", "Total value for the year " + this.commonService.LastYear + " must tally with the Current Assets - Current Investments value in the Trial balance for the year " + this.commonService.LastYear + ".", "warning")
        else
          Swal.fire("Andica Accounts Production", "Total value for the year " + this.commonService.StartYear + " must tally with the Current Assets - Investments value in the balance sheet for the year " + this.commonService.StartYear + ".", "warning")

        //Swal.fire({
        //  text: "'Total' value for the year'" + this.commonService.StartYear + "'must tally with the 'Investments held as current assets' value in the balance sheet for the year " + this.commonService.StartYear + ".",
        //  showConfirmButton: true,
        //  icon: 'warning',

        //})
        return false;
      }
      else
        return true
      // return true
    }
    else {
      if (+this.InvestmentsHeldPartnershipFormGroup.controls['CurrentAssetInvestments'].value != this.InvestmentsHeldPartnershipFormGroup.controls['MatchingData'].value.Item1) {
        if (this.commonService.AccountTypeId == 2)
          Swal.fire("Andica Accounts Production", "Total value for the year " + this.commonService.LastYear + " must tally with the Current Assets - Current Investments value in the Trial balance for the year " + this.commonService.LastYear + ".", "warning")
        else
          Swal.fire("Andica Accounts Production", "Total value for the year " + this.commonService.StartYear + " must tally with the Current Assets - Investments value in the balance sheet for the year " + this.commonService.StartYear + ".", "warning")
        //Swal.fire({
        //  text: "'Total' value for the year'" + this.commonService.StartYear + "'must tally with the 'Investments held as current assets' value in the balance sheet for the year " + this.commonService.StartYear + ".",
        //  showConfirmButton: true,
        //  icon: 'warning',

        //})
        return false;
      }
      else
        return true
      // return true
    }
  }

  On_Back() {
    debugger;
    this.InvestmentsHeldPartnershipFormGroup.markAsPristine();
    var backpage;
    if (this.isJump == 'true')
      this.Router.navigate(['/notes'])
    else {
      backpage = this.commonService.getBackSelection("Investments held as current assets", this.commonService.NotesList)
      this.Router.navigate([backpage]);
    }
  }

  Calculations() {
    debugger;
    var total1 = +this.InvestmentsHeldPartnershipFormGroup.controls['ListedExchangeTraded'].value + +this.InvestmentsHeldPartnershipFormGroup.controls['UnlistedNonøexchangeTraded'].value;
    var total2 = +this.InvestmentsHeldPartnershipFormGroup.controls['ListedExchangeTraded_LY'].value + +this.InvestmentsHeldPartnershipFormGroup.controls['UnlistedNonøexchangeTraded_LY'].value;
    this.InvestmentsHeldPartnershipFormGroup.controls['CurrentAssetInvestments'].setValue(total1 == 0 ? '' : total1);
    this.InvestmentsHeldPartnershipFormGroup.controls['CurrentAssetInvestments_LY'].setValue(total2 == 0 ? '' : total2);
  }

  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    debugger;
    if (this.InvestmentsHeldPartnershipFormGroup.dirty) {
      return Swal.fire({
        title: "Andica Accounts Production",
        html: "<span style='font-weight: 900'>You have unsaved data.</span> <br>Do you want to save your changes before leaving?",
        icon: "warning",
        confirmButtonText: "Save Changes",
        showCancelButton: true,
        cancelButtonText: "Discard Changes",
        allowOutsideClick: false
      }).then((result) => {
        if (result.value) {
          this.NormalRoutng = true;
          if (this.On_Next())
            return true;
          else if (!this.NormalRoutng)
            return false;
        }
        else {
          return true;
        }
      })
    }
    else if (this.commonService.routeToCompanyList) {
      return true
    }
  }

  TotalBack() {
    debugger;
    this.commonService.DisplayAccountingPeriodlist = true;
    this.Router.navigate(['/business']);

  }


}
